// What a shop needs on its own record before it can print a tax invoice, said
// in words a shopkeeper uses.
//
// The RULE lives on the server, once, in backend/common/seller.py: it refuses
// POST /api/sales and it decides `tenant.invoice_ready` on /auth/me. Nothing
// here re-derives it — a shell that thinks the shop is fine while the till
// refuses every bill is worse than no banner at all. What lives here is the
// WORDING, because these are the labels on the Settings form and a sentence
// built on the server would be a second copy of them to keep in step.
//
// Two screens read this: the shell banner, which is on every page until it is
// fixed, and Billing, which disables Post and says why rather than letting a
// cashier type forty lines to be told at the end.

export const SHOP_FIELD_LABELS = {
  gstin: 'GSTIN',
  address_line1: 'address',
  city: 'city',
  postal_code: 'PIN code',
}

/** "GSTIN, address and city" — the same English list the server's refusal uses. */
export function nameTheMissing(columns) {
  const labels = (columns ?? []).map((column) => SHOP_FIELD_LABELS[column] ?? column)
  if (labels.length <= 1) return labels[0] ?? ''
  return `${labels.slice(0, -1).join(', ')} and ${labels[labels.length - 1]}`
}

/**
 * Whether the server has said this shop cannot bill yet.
 *
 * `=== false`, not `!tenant.invoice_ready`: a client running against a server
 * that predates the field would otherwise block billing for every shop,
 * permanently, with nothing actually broken.
 */
export function shopCannotInvoice(tenant) {
  return tenant?.invoice_ready === false
}

/** The one sentence both screens say about it. */
export function incompleteShopNotice(tenant) {
  return (
    `No bills can be posted yet: this shop has no ${nameTheMissing(tenant?.invoice_missing)} ` +
    'on record, so an invoice would not be a valid tax invoice.'
  )
}
